<template>
  <div>
    <v-row>
      <v-icon>mdi-tag</v-icon>
      <div>{{ $t("story.tags") }}</div>
    </v-row>
    <v-row>
      <v-autocomplete
        v-model="tags"
        :items="availableTags"
        :label="$t('story.basicInfoForm.addTags')"
        single-line
        outlined
        solo
        multiple
        item-text="_id"
        item-value="id"
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click="data.select"
            @click:close="removeTag(data.item)"
          >
            {{ data.item._id }}
          </v-chip>
        </template>
      </v-autocomplete>
    </v-row>
  </div>
</template>
<script>
import gql from "graphql-tag";
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      tags: this.value,
    };
  },
  methods: {
    removeTag(tagToRemove) {
      const index = this.tags.indexOf(tagToRemove.id);
      if (index >= 0) this.tags.splice(index, 1);
    },
  },
  watch: {
    tags(newValue) {
      this.$emit("input", newValue);
      if (this.availableTags) {
        const tagsObject = this.availableTags.filter(
          (tag) => newValue.indexOf(tag.id) >= 0
        );
        this.$emit("tagsObject", tagsObject);
      }
    },
    value(newValue) {
      if (this.tags != newValue) {
        this.tags = newValue;
      }
    },
  },
  apollo: {
    availableTags: {
      query: gql`
        query {
          storyTags {
            _id
            id
          }
        }
      `,
      update(data) {
        return data.storyTags;
      },
    },
  },
};
</script>